/*
 * File: /src/store/modules/callResults.js
 * Created Date: Saturday March 16th 2019
 * Author: Nicolas Wegener
 * -----
 * Last Modified: Sunday, 17th March 2019 4:19:09 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import LeadStatusService from 'src/services/leadStatusService';

const state = {
  leadStatuses: undefined
};

const getters = {
  getLeadStatuses: (state) => state.leadStatuses,
};
const actions = {
  async fetchLeadStatuses({ commit, state, rootGetters }) {
    // Only load the data once
    if (state.leadStatuses == undefined) {
      return LeadStatusService.fetchAll()
      .then(r => {
        commit('setLeadStatuses', r.data);
      });
    }
  },
  unloadLeadStatuses({ commit }) {
    commit('setLeadStatuses', undefined);
  }
};
const mutations = {
  setLeadStatuses(state, statuses) {
    state.leadStatuses = statuses;
    // state.leadStatuses = Object.assign([], statuses);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
